import React, { useState, useEffect } from "react";
import { getCartItems, getCartInfo } from "../../../service/cartService";
import { getListPromotion } from "../../../service/campaignService";
import { isAuth } from "../../../helpers/general";
import CartItems from "./cartitem";
import CartMobileEmpty from "./cartEmptyMobile";

const CartListMobile = (props) => {
    const [reloadCartCout, setReloadCart] = useState(false);
    const reloadCart = () => {
        loadCart();
        setReloadCart(!reloadCartCout);
    }
    const [msg, setMsg] = useState();
    const [count_cart, setCountCart] = useState(0);
    const data_items = [];
    
    let data_items_gifts = [];
    var [dataItemGift, setDataItemGift] = useState([]);
    const item_cart = [];
    var [dataItems, setdataItems] = useState([]);
    const loadCart = () => {
        const data_items_gift = [];
        try {
            if (window.localStorage.getItem('key') !== '') {
                window.localStorage.setItem("tempCart", JSON.stringify([]));
                getCartItems(window.localStorage.getItem('key')).then((response) => {
                    window.localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    let CartItems = response['message'];
                    if (response['message'] === 'Yêu cầu không hợp lệ' || response.status === 400 || response.status === 500) {
                        CartItems = [];
                        return;
                    }
                    if (CartItems.length > 0) {
                        var _items = [];
                        const groupedItemsByPromotionAndType = {};
                        CartItems?.forEach((item) => {
                            let _price = 0;
                            if (item.product?.price?.raw) {
                                if (item.product?.price?.raw !== undefined && item.product?.price?.raw > item.product?.price?.discount) {
                                    _price = item.product?.price?.discount;
                                } else {
                                    _price = item.product?.price?.raw;
                                }
                            }
                            let cart = {
                                id: item.product?._id,
                                sku: item.product?.sku,
                                linksp: item.product?.linksp,
                                quantity: item.quantity,
                                name: item.product?.name,
                                image: item.product?.thumbnail_mini,
                                price: _price,
                                price_old: item.product?.price?.raw,
                                saving_money: +item.product?.price?.raw - _price,
                                color: item.product?.variant?.mau_sac,
                                size: item.product?.variant?.kich_c,
                                bixu: item.product?.bixu,
                                type: item.type,
                                promo_code: item.promo_code ?? '',
                                promo_type: item.promo_type ?? '',
                                uudai: item.uudai,
                                typectkm: item.product?.typectkm,
                                msg: JSON.stringify(item.validator?.messages)?.replaceAll('[', '').replaceAll(']', '').replaceAll('"', '')
                            }
                            data_items.push(cart);

                            if( item.type === 'gift'){
                                let _param = {
                                "product": item.product?.sku,
                                "type": item.type,
                                "action": "update",
                                "quantity": item.quantity,
                                "price": _price,
                                "promo_code": item.promo_code ?? '',
                                "combo_code": item.promo_type ?? '',
                                "uudai": item.uudai,
                                "user_referral": window.localStorage.getItem('userReferral'),
                                "id_share": window.localStorage.getItem('idShare')
                              }
                              data_items_gift.push(_param)
                            }
                            
                            _items.push({ 
                                item_id: item.product?.sku,
                                item_name: item.product?.name,
                                price: +_price
                            });
                            const { promo_code, type } = item;
                            if (!groupedItemsByPromotionAndType[promo_code]) {
                                groupedItemsByPromotionAndType[promo_code] = {
                                    'gift': [],
                                    'nonGift': []
                                };
                            }
                            if(cart.quantity > 0){
                                if (type === 'gift') {
                                    groupedItemsByPromotionAndType[promo_code]['gift'].push(cart);
                                } else {
                                    groupedItemsByPromotionAndType[promo_code]['nonGift'].push(cart);
                                }
                            }
                            let _item = {
                                itemCode: item.product?.sku,
                                price: _price,
                                quantity: item.quantity
                            }
                            item_cart.push(_item);
                        });
                        window.localStorage.setItem("tempCart", JSON.stringify(data_items_gift));
                        getCartInfo(window.localStorage.getItem('key')).then((response) => {
                            if (response.status === 200) {
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push({
                                        'event': 'begin_checkout',
                                        'ecommerce': {
                                        'currency': "VND",
                                        'value': +response['message'][0]?.total,
                                            'items': _items
                                        },
                                        'eventCallback': function() {
                                        }
                                    });

                                    window.localStorage.setItem('layoutGA', JSON.stringify({
                                        'event': 'purchase',
                                        'ecommerce': {
                                        'currency': "VND",
                                        'value': +response['message'][0]?.total,
                                        'user_id': window.localStorage.getItem('_id') ?? '',
                                        'items': _items
                                        },
                                        'eventCallback': function() {
                                        }
                                    }));
                            }
                            
                        });
                        data_items_gifts = Object.values(groupedItemsByPromotionAndType);
                        setDataItemGift(data_items_gifts);
                    }
                   
                    setdataItems(data_items);
                    LoadDataPromotion(item_cart);

                });
            }

        } catch (err) {
            console.error(err);
        }
    }
    const LoadDataPromotion = (param) => {
        getListPromotion(param).then((response) => {
            if (response.status === 200) {
                setMsg(response.message?.mes_text);
            }
        });
    }

    useEffect(() => {
        window.localStorage.setItem("tempCart", JSON.stringify([]));
        loadCart();
    }, []
    );
    return (
        <>
        
            {
                (+dataItems.length > 0 && isAuth() === true) ? (
                    <CartItems key="cartitems" items={dataItems} item_gifts={dataItemGift} parentCallback={reloadCart} msg={msg}/>
                ) : (
                    <CartMobileEmpty key="cartempty" />
                )
            }
        </>
    )
}
export default CartListMobile;